import { useState } from 'react';
import { Link } from 'react-router-dom';
import Section from '../../atoms/section/section.atom';

import EcommerceSVG from '../../vectors/ecommerce.svg';

import { SectionsScrollContainer } from './sections-scroll.styles';

const SectionsScroll = ({ 
    displays = [],
    selected,
    sectionClick
}) => {
    
    return (
        <SectionsScrollContainer>
            <div className='sections-scroll-box'>
                <div className='sections-scroll'>
                    {
                        displays.map((display, i) => <Section
                            key={i}
                            br={selected === i ? 'solid rgba(0,0,0,0.5) 0.5px' : 'solid rgba(255,255,255,0.4) 0.5px'}
                            bg={selected === i ? 'rgba(0,0,0,0.5)' : 'transparent'}
                            icon={<EcommerceSVG />}
                            title={display.name}
                            clickHandler={() => sectionClick(i)}
                          />
                        )
                    }
                </div>
            </div>
        </SectionsScrollContainer>
    )
}

export default SectionsScroll;